<div class="date-picker-multiselect" [ngClass]="{'date-picker-multiselect-readonly': readonly}">

    <div class="row no-gutters">
        <div class="col-sm-3 text-left " (click)="onPreviousMonth() "><i class="i-arrow-left ml-3 "></i></div>
        <div class="col-sm-6 text-center "><span class="month ">{{month}}</span> <span
                class="year ml-2 ">{{year}}</span></div>
        <div class="col-sm-3 text-right " (click)="onNextMonth() "><i class="i-arrow-right mr-3 "></i></div>
    </div>

    <div class="row mt-2 no-gutters ">
        <div class="col-sm text-center week-day">Sun</div>
        <div class="col-sm text-center week-day ml-2 ">Mon</div>
        <div class="col-sm text-center week-day ml-2 ">Tue</div>
        <div class="col-sm text-center week-day ml-2 ">Wed</div>
        <div class="col-sm text-center week-day ml-2 ">Thu</div>
        <div class="col-sm text-center week-day ml-2 ">Fri</div>
        <div class="col-sm text-center week-day ml-2 ">Sat</div>
    </div>

    <div class="row no-gutters mt-2 " *ngFor="let item of days | groupBy: 'week' ">
        <div class="col-sm text-center day " *ngFor="let day of item.value; let i=index "
            [ngClass]="{ 'day-selected': isSelected(day), 'ml-2': i> 0, 'day-not-from-current-month': !day.isFromCurrentMonth, 'day-cannot-select-past': cannotSelectPast(day)}"
            [ngStyle]="{'border-color': isSelected(day) && selectColor != null ? selectColor : 'transparent'}"
            (click)="onSelectDay(day)">
            {{day.date.format('DD')}}
        </div>
    </div>
</div>